import styled from 'styled-components'

export const BudgetCategoryAttributesPopoverStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
